import request from './api';

// SKU成本配置
export interface SKUCostConfig {
    id: number;
    seller_sku: number;
    seller_sku_code: string;
    seller_sku_name: string;

    purchase_cost: number;
    purchase_currency: string;
    shipping_to_fba: number;
    packaging_cost: number;
    other_cost: number;

    estimated_fba_fee: number;
    referral_fee_rate: number;

    exchange_rate_to_usd: number;

    total_cost_cny: number;
    total_cost_usd: number;

    notes: string;
    updated_at: string;
}

// 订单利润报表
export interface OrderProfitReport {
    id: number;
    seller_sku_code: string;
    seller_sku_name: string;
    shop_name: string;
    report_date: string;

    units_sold: number;
    gross_sales: number;
    currency: string;

    units_refunded: number;
    refund_amount: number;

    fba_fees: number;
    referral_fees: number;
    other_amazon_fees: number;

    cogs: number;
    net_revenue: number;
    gross_profit: number;
    profit_margin: number;
}

// 利润汇总
export interface ProfitSummary {
    total_revenue: number;
    total_refunds: number;
    total_amazon_fees: number;
    total_cogs: number;
    total_profit: number;
    avg_profit_margin: number;
    total_units: number;
}

// 趋势数据点
export interface ProfitTrendPoint {
    period: string;
    revenue: number;
    profit: number;
    units: number;
    avg_margin: number;
}

// 利润排行数据
export interface ValidRankingItem {
    seller_sku: number;
    seller_sku__sku_code: string;
    seller_sku__product_name: string;
    revenue: number;
    profit: number;
    units: number;
    avg_margin: number;
}

export const financeService = {
    // 获取SKU成本配置列表
    getCostConfigs(params?: any) {
        return request.get('/api/sku-cost-configs/', { params });
    },

    // 创建SKU成本配置
    createCostConfig(data: Partial<SKUCostConfig>) {
        return request.post('/api/sku-cost-configs/', data);
    },

    // 更新SKU成本配置
    updateCostConfig(id: number, data: Partial<SKUCostConfig>) {
        return request.patch(`/api/sku-cost-configs/${id}/`, data);
    },

    // 批量更新成本配置
    batchUpdateCostConfig(configs: Partial<SKUCostConfig>[]) {
        return request.post('/api/sku-cost-configs/batch_update/', { configs });
    },

    // 获取订单利润报表
    getProfitReports(params?: any) {
        return request.get('/api/profit-reports/', { params });
    },

    // 获取利润汇总
    getProfitSummary(params?: any) {
        return request.get('/api/profit-reports/summary/', { params });
    },

    // 获取利润趋势
    getProfitTrend(params?: any) {
        return request.get('/api/profit-reports/trend/', { params });
    },

    // 获取SKU利润排行
    getProfitRanking(params?: any) {
        return request.get('/api/profit-reports/sku_ranking/', { params });
    },

    // 触发利润重算
    recalculateProfit(data: { start_date: string; end_date: string; shop_id?: number }) {
        return request.post('/api/profit-reports/recalculate/', data);
    },
};
